import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useMerchantDemo } from '../hooks/useMerchantDemo';

/** Redirige le commerçant démo vers le choix de catégorie tant qu'il n'en a pas sélectionné une. */
export default function MerchantDemoGate() {
  const { isDemoMerchant, needsCategory } = useMerchantDemo();
  const location = useLocation();

  if (!isDemoMerchant) {
    return <Outlet />;
  }

  const onPicker = location.pathname === '/demo/commerce';

  if (needsCategory && !onPicker) {
    return <Navigate to="/demo/commerce" replace />;
  }

  return <Outlet />;
}
